import { __assign, __read, __rest } from "tslib";
import { useOnThemeChanged, useShellShimReact, } from '@office-start/shell-shim-service';
import { logError } from '@office-start/telemetry-service';
import { HarmonyThemeType, OfficeThemeMode, } from '@office-start/theming-types';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDefaultHarmonyTheme } from './useHarmonyTheming';
var getBaseThemeColorsFromShell = function (shellBaseTheme) {
    if (!!((shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Darker) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Dark) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.DarkAlt) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Primary) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Secondary) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Tertiary) &&
        (shellBaseTheme === null || shellBaseTheme === void 0 ? void 0 : shellBaseTheme.Light))) {
        return {
            Darker: shellBaseTheme.Darker,
            Dark: shellBaseTheme.Dark,
            DarkAlt: shellBaseTheme.DarkAlt,
            Primary: shellBaseTheme.Primary,
            Secondary: shellBaseTheme.Secondary,
            Tertiary: shellBaseTheme.Tertiary,
            Light: shellBaseTheme.Light,
            // Lighter and LighterAlt are optional
            Lighter: shellBaseTheme.Lighter || '',
            LighterAlt: shellBaseTheme.LighterAlt || '',
        };
    }
    return undefined;
};
export var useShellTheme = function () {
    var defaultHarmonyTheme = useDefaultHarmonyTheme();
    var shellShim = useShellShimReact();
    var isMounted = useRef(true);
    var _a = __read(useState(undefined), 2), shellThemeInfo = _a[0], setShellThemeInfo = _a[1];
    useEffect(function () {
        return function () {
            isMounted.current = false;
        };
    }, []);
    // Listen for theme changes
    var onThemeChange = useCallback(function (themeInfo) {
        var IsDarkMode = themeInfo.IsDarkMode, ThemeType = themeInfo.ThemeType, ThemeId = themeInfo.ThemeId, PreferOfficeTheme = themeInfo.PreferOfficeTheme;
        // Shell onThemeChange callback does not provide all the colors needed.
        // For example, for 'base' theme in dark mode, the theme id returned is 'base_dark'
        // and it omits the 'DarkTheme' entry on the themeInfo and treats the default colors,
        // (which we would normally treat as light) as dark.
        // To avoid this, and to get all the colors, we'll call the shell shim.
        if (!shellShim) {
            return;
        }
        shellShim.Theme.GetUserThemeJsonByID(ThemeId, function (shellTheme) {
            var darkShellTheme = shellTheme.DarkTheme, lightShellTheme = __rest(shellTheme, ["DarkTheme"]);
            var lightColors = getBaseThemeColorsFromShell(lightShellTheme);
            var darkColors = getBaseThemeColorsFromShell(darkShellTheme);
            if (!lightColors) {
                logError({
                    eventName: "ShellThemeMissingLightColors_".concat(shellTheme === null || shellTheme === void 0 ? void 0 : shellTheme.Id),
                });
                // Do not set theme if we don't have correct colors
                return;
            }
            // If we have dark colors for the theme, then the theme is valid.
            // Otherwise, fall back to the default Harmony theme colors.
            var colors = darkColors
                ? __assign(__assign({}, lightColors), { DarkTheme: darkColors }) : defaultHarmonyTheme.colors;
            if (!isMounted.current) {
                return;
            }
            setShellThemeInfo({
                colors: colors,
                colorOverrides: {
                    token: IsDarkMode,
                },
                id: ThemeId,
                mode: IsDarkMode
                    ? OfficeThemeMode.dark
                    : OfficeThemeMode.default,
                preferOfficeTheme: PreferOfficeTheme,
                themeType: ThemeType,
                type: HarmonyThemeType.Shell,
            });
        });
    }, [defaultHarmonyTheme.colors, shellShim]);
    useOnThemeChanged(onThemeChange);
    return shellThemeInfo;
};
//# sourceMappingURL=useShellTheme.js.map